export default function (src, dest, me, input) {
    dest.key = src.key;
    dest.prefix = src.prefix;
    dest.type = src.type;
    dest.statut = src.statut;

    dest.uuid = src.uuid;
    dest.fonction = src.fonction;
    dest.email = src.email;
    dest.telephone = src.telephone;
    dest.civilite = src.civilite;
    dest.estFondateur = src.estFondateur != null ? src.estFondateur : true;

    if ("physique" === dest.type || input) {
        dest.nom = src.nom;
        dest.prenom = src.prenom;
        dest.nationalite = src.nationalite;
    }

    if ("reprise" === dest.type || input) {
        dest.description = src.description;
    }

    if ("morale" === dest.type || input) {
        dest.formeJuridique = src.formeJuridique;
        dest.denomination = src.denomination;
        dest.nomRepresentant = src.nomRepresentant;
        dest.prenomRepresentant = src.prenomRepresentant;
        dest.numeroInscription = src.numeroInscription;
    }

    if (src.description || input) {
        dest.description = src.description;
    }


    //commun physique/morale
    const adresse = src.adresse;
    if (adresse) {
        dest.adresse = {
            adresse: adresse.adresse,
            complementAdresse: adresse.complementAdresse,
            codePostal: adresse.codePostal,
            commune: adresse.commune,
            pays: adresse.pays
        };
    } else {
        dest.adresse = null;
    }
}

